import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
    baseURL: API,
    withCredentials: true,  // send session_token cookie for Google Auth
});

api.interceptors.request.use((config) => {
    const t = localStorage.getItem("utal_token");
    if (t) config.headers.Authorization = `Bearer ${t}`;
    return config;
});

export default api;
